import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { ComponentProps } from 'react'

import { TopicEntry } from './TopicEntry'

type SortableTopicEntryProps = Omit<
  ComponentProps<typeof TopicEntry>,
  'sortableRef' | 'sortableStyle' | 'dragHandle'
> & {
  id: string
}

export function SortableTopicEntry({ id, ...topicEntryProps }: SortableTopicEntryProps) {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1 : undefined,
  }

  return (
    <TopicEntry
      {...topicEntryProps}
      sortableRef={setNodeRef}
      sortableStyle={style}
      dragHandle={{ setActivatorNodeRef, attributes, listeners }}
    />
  )
}
